/** Date utilities. Local-time based — Italian office hours, no UTC nonsense. */

export function pad2(n: number): string {
  return n < 10 ? `0${n}` : `${n}`;
}

export function daysInMonth(year: number, month: number): number {
  return new Date(year, month + 1, 0).getDate();
}

/** Build the calendar's canonical "YYYY-MM-DD" key. month is 0-indexed. */
export function dateKey(year: number, month: number, day: number): string {
  return `${year}-${pad2(month + 1)}-${pad2(day)}`;
}

/** Parse "YYYY-MM-DD" → [year, month-0-indexed, day]. */
export function parseDateKey(key: string): [number, number, number] {
  const [y, m, d] = key.split("-").map(Number);
  return [y ?? 0, (m ?? 1) - 1, d ?? 1];
}

/** Friendly day formatting for tooltips: "Mon 15 April". */
export function formatDayLabel(key: string): string {
  const [y, m, d] = parseDateKey(key);
  const dt = new Date(y, m, d);
  const wd = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][dt.getDay()];
  const month = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ][m];
  return `${wd} ${d} ${month}`;
}

export function isWeekend(year: number, month: number, day: number): boolean {
  const wd = new Date(year, month, day).getDay();
  return wd === 0 || wd === 6;
}
